import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useT } from '../i18n';
import { BackIcon } from './Icons';

/** Screen title; `back` shows a large back arrow (history back, or the given path when opened directly). */
export function PageHeader({ title, back, sub, right }: { title: ReactNode; back?: string; sub?: ReactNode; right?: ReactNode }) {
  const t = useT();
  const nav = useNavigate();
  return (
    <header className="mb-4 flex items-start gap-1 pt-4">
      {back ? (
        <button
          type="button"
          aria-label={t('common.back')}
          className="-ml-3 inline-flex min-h-tap min-w-tap items-center justify-center rounded-xl"
          onClick={() => (window.history.length > 1 ? nav(-1) : nav(back))}
        >
          <BackIcon />
        </button>
      ) : null}
      <div className="min-w-0 flex-1 pt-2">
        <h1 className="break-words">{title}</h1>
        {sub ? <div className="mt-1 text-[14px] text-lab">{sub}</div> : null}
      </div>
      {right}
    </header>
  );
}
